// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__vU8lZ","bigColWidth":"Table_bigColWidth__22FUE","biggerColWidth":"Table_biggerColWidth__3xrjB","row":"Table_row__RcQnP","col":"Table_col__15d2Z"};